// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"2a530ee2","765":"7ee10073"}[chunkId] + ".chunk.css";
};